import { useIframeMessages } from '@hooks/useIframeMessages'
import { Box } from '@mui/material'

export const Groups = () => {
  const { registerIframe } = useIframeMessages({})
  return (
    <Box
      style={{
        width: '100%',
        height: '94vh',
        overflow: 'hidden',
        margin: 0,
        padding: 0,
      }}
    >
      <iframe
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          display: 'block',
          margin: 0,
          padding: 0,
        }}
        src={`${process.env.REACT_APP_GROUPS_URL}/administration/groups`}
        onLoad={() => registerIframe(window)}
      ></iframe>
    </Box>
  )
}
